import { WarningOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import Button from 'app/components/UI-Elements/General/Button'
import useTranslation from 'app/lib/hooks/useTranslation'
import testIds from 'test_ids.json'

import { useCurrentIncidentSubject } from './CurrentSubject'
import { IncidentSubject } from './typing'
import { useIncidentReportingEnabled, useReportIncident } from './useReportIncident'

type Props = Omit<React.ComponentProps<typeof Button>, 'onClick' | 'title'> & {
  subject?: IncidentSubject
  iconOnly?: boolean
}

const ReportButton: React.FC<Props> = ({ subject, iconOnly, ...buttonProps }) => {
  const { t } = useTranslation()
  const reportIncident = useReportIncident()
  const currentSubject = useCurrentIncidentSubject()
  const enabled = useIncidentReportingEnabled()
  const label = t({ id: 'record.incident.report.button' })

  if (!enabled) return null

  const button = (
    <Button
      icon={<WarningOutlined />}
      shape={iconOnly ? 'circle' : undefined}
      type={iconOnly ? 'text' : 'default'}
      aria-label={label}
      data-testid={testIds.modules.incident.report_button}
      {...buttonProps}
      onClick={() => reportIncident(subject ?? currentSubject)}>
      {!iconOnly && label}
    </Button>
  )

  return iconOnly ? <Tooltip title={label}>{button}</Tooltip> : button
}

export default ReportButton
